import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import { SmallCheckbox } from '../Forms/Checkboxes';
import CellBase from './CellBase';

export default class CheckboxCell extends CellBase {
    static displayName = displayName('TableView/CheckboxCell');

    static propTypes = {
        ...CellBase.propTypes,
        isChecked: PropTypes.bool.isRequired,
        indeterminate: PropTypes.bool.isRequired,
        isDisabled: PropTypes.bool,
        forceHover: PropTypes.bool,
        type: PropTypes.oneOf(['normal', 'small']),
    };

    static defaultProps = {
        ...CellBase.defaultProps,
        isDisabled: false,
        forceHover: false,
        indeterminate: false,
        cellType: 'checkbox',
        type: 'normal',
    };

    static contextTypes = CellBase.contextTypes;

    onCellClick = () => {
        const { onClick = () => {}, cellId, isChecked } = this.props;

        onClick(cellId, !isChecked);
    };

    renderCell() {
        const {
            isChecked,
            isDisabled,
            indeterminate,
            forceHover,
            type,
        } = this.props;

        return (
            <SmallCheckbox
                type={type}
                forceHover={forceHover}
                checked={isChecked}
                indeterminate={indeterminate}
                disabled={isDisabled}
            />
        );
    }
}
